import { ANIMATION_VARIATIONS_FRAMES } from '@/map-phaser-new/constants'
import type { AnimationsData } from '@/map-phaser-new/interfaces'

export const cableCarRightToDownAnimations: AnimationsData[] = [
  {
    animationCreationData: {
      animationName: 'cableCarRightToDownAnimations1',
      skipMissedFrames: true,
      defaultTextureKeyPostfix: '25',
      delay: 0,
      duration: 500,
      showOnStart: true,
      hideOnComplete: false,
    },
    framesData: {
      type: ANIMATION_VARIATIONS_FRAMES.GenerateFrameNames,
      frames: {
        start: 25,
        end: 20,
        zeroPad: 2,
      },
    },
  },
]
